import { ArticlesDetailComponent } from './articles-detail/articles-detail.component';
import { InterviewComponent } from './interview/interview.component';
import { CaseStudyDetailComponent } from './case-study-detail/case-study-detail.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NewsletterIdeaSidebarComponent } from './shared/newsletter-idea-sidebar/newsletter-idea-sidebar.component';
import { CaseStudyComponent } from './case-study/case-study.component';
import { InterviewDetailComponent } from './interview-detail/interview-detail.component';
import { NewsComponent } from './news/news.component';
import { ArticlesComponent } from './articles/articles.component';
import { NgoOfMonthComponent } from './ngo-of-month/ngo-of-month.component';

const routes: Routes = [
  {
    path: 'sidebar',
    component: NewsletterIdeaSidebarComponent,
    pathMatch: 'full'
  },
  {
    path: 'case-study',
    component: CaseStudyComponent,
    pathMatch: 'full'
  },
  {
    path: 'case-study/detail/:id',
    component: CaseStudyDetailComponent,
    pathMatch: 'full'
  },
  {
    path: 'interview',
    component: InterviewComponent,
    pathMatch: 'full'
  },
  {
    path: 'interview/detail/:id',
    component: InterviewDetailComponent,
    pathMatch: 'full'
  },
  {
    path: 'news',
    component: NewsComponent,
    pathMatch: 'full'
  },
  {
    path: 'articles',
    component: ArticlesComponent,
    pathMatch: 'full'
  },
  {
    path: 'article/detail/:id',
    component: ArticlesDetailComponent,
    pathMatch: 'full'
  },
  {
    path: 'ngo',
    component: NgoOfMonthComponent,
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KnowledgeSectionRoutingModule { }
